import gql from 'graphql-tag';

import MinimalUserProfile from './minimal_user_profile';

export default gql`
  fragment UpdatedContent on UpdatedContent {
    user_id
    client_id
    content_id
    share_count
    click_count
    comment_count
    reaction_count
    shared_by {
      ...MinimalUserProfile
    }
    reacted_by {
      ...MinimalUserProfile
    }
    commented_by {
      ...MinimalUserProfile
    }
  }
  ${MinimalUserProfile}
`;
